<template>
  <div>
    <form @submit="onApprove">
      <div class="btn-wrapper">
        <span style="float: left;">
          <form>
            <label for="searchByTicket">ticket</label>
            <input type="text" placeholder=" 請輸入要查詢的ticket" style="margin-left: 5px;" v-model="searchTicket">
            <button style="margin-left: 10px;" @click.prevent="searchByTicket">查詢</button>
          </form>
        </span>
        <button class="approve-btn" type="submit">審核</button>
      </div>
      <div class="approve-item-container">
        <div
          v-for="ticket in updatedTickets"
          :key="ticket"
          class="approve-item"
        >
          <checkbox
            type="checkbox"
            :label="ticket"
            @change="checked=>{onChangeItem(ticket, checked)}"
            @click="showDiff"
          />
        </div>
      </div>
    </form>

    <modal name="ticket" :styles="{ padding: '15px' }" width="800px" height="1000px" @before-close="onDiffModalClose">
      <div style="max-height: 1000px; overflow-y: auto;">
        <a target="_blank" style="float: left; margin-top: 5px; margin-right: 5px; font-size: 28px;" :href="'https://innotech.atlassian.net/browse/' + selectedTicket">{{ selectedTicket }}</a>
        <div v-for="(history, i) in cardsHistory" :key="i" style="margin-bottom: 30px;">
          <div v-for="(detail, index) in formatContent(history)" :key="`detail-${detail.id}`">
            <div v-if="index===0" class="key" style="margin-top: 50px; margin-bottom: 15px;">
              {{ detail.key }}
            </div>
            <div style="display: flex;">
              <div v-if="detail.old" class="old" style="flex: 0 0 50%;">
                <div v-for="(lang, index) in detail.old" :key="index" style="margin-top: 5px; margin-bottom: 5px;">
                  <div v-if="index<5">
                    <span v-if="index===0" style="margin-left: 5px;"></span>
                    <span style="font-weight:bold;">{{ `${detail.old[index]}` }}</span>
                  </div>
                  <div v-else>
                    {{ `${detail.old[index]}` }}
                  </div>
                </div>
              </div>
              <div v-if="detail.new" class="new" style="flex: 0 0 50%" >
                <div v-for="(lang, index) in detail.new" :key="index" style="margin-top: 5px; margin-bottom: 5px;">
                  <div v-if="index<5">
                    <span v-if="index===0" style="margin-left: 5px;"></span>
                    <span style="font-weight:bold;">{{ `${detail.new[index]}` }}</span>
                  </div>
                  <div v-else>
                    {{ `${detail.new[index]}` }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </modal>

    <modal
      name="approve"
      :styles="{ padding: '10px', 'max-height': '400px' }"
      height="auto"
      :maxHeight="400"
      :clickToClose="!isApproving"
      @before-close="onModalClose"
      @closed="onApproveModalClosed"
    >
      <div class="approve-modal-container" :aria-busy="isApproving">
        <div v-if="isApproving" class="approve-loading-overlay" role="status" aria-live="polite">
          <img src="@/assets/loading.svg" alt="">
          <div>審核中…</div>
        </div>
        <div class="modal-title">確認審核</div>
        <div class="modal-body">
          <div class="confirm-approve-title">確認以下 JIRA 單通過審核：</div>
          <div class="confirm-approve-tickets-container">
            <div
              v-for="ticket in selectedTicketList"
              :key="'approve-card-' + ticket"
              class="confirm-approve-ticket-item"
            >
              {{ ticket }}
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="button cancel-btn" :disabled="isApproving" @click="cancel">
            取消
          </button>
          <button
            type="button"
            class="button confirm-btn"
            :disabled="isApproving"
            @click="confirmApprove"
          >
            確認
          </button>
        </div>
      </div>
    </modal>

    <footer class="footer">
      <select v-model="selectedPageSize.value" @change="onChange">
        <option v-for="option in paginationOptions" :value="option.value" :key="option.value">
          {{ option.name }}
        </option>
      </select>
      <span style="display: inline-block; margin-left: 25px;">
        共 {{ showingRecords }}/{{ totalCount }} 條記錄
      </span>
      <button type="button" class="nextPage" @click="goToNextPage">&#8594;</button>
      <span class="pages">
        {{ pageNum }}/{{ totalPages }}
      </span>
      <button type="button" class="prevPage" @click="goToPrevPage">&#8592;</button>
    </footer>

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Checkbox from "@/components/checkbox.vue";

export default {
  name: "ApprovePanel",
  components: {Checkbox},
  data(){
    return {
      selectedTicketList:[],
      isApproving: false,
      isLoaded: false,
      selectedTicket: '',
      searchTicket: '',
      selectedPageSize: {
        name:'50 條顯示列數', value: 50
      },
      paginationOptions: [
        {
          name: '10 條顯示列數', value: 10
        },
        {
          name: '25 條顯示列數', value: 25
        },
        {
          name:'50 條顯示列數', value: 50
        },
        {
          name:'100 條顯示列數', value: 100
        }
      ],
      pageNum: 1,
      pageSize: 50,
      totalPages: 1,
      totalCount: 1,
      showingRecords: 1
    }

  },
  created() {
    this.$store.dispatch("getUpdatedTickets", this.getPayload());
  },
  computed: {
    ...mapGetters(["updatedTickets", "project", "isConfirmApproveModalOpen", "approvedCards", "cardsHistory", "langs","isLoading", "updatedTicketsPage"]),
    // isSelected(ticket) {
    //   return this.selectedTicketList.includes(ticket) && !this.isLoading
    // }
  },
  methods: {
    getDiffContent(changes) {
      return this.langs.map(d => {
        if (changes.before[d] !== changes.after[d]) {
          return {
            key: `${changes.before.key}`,
            old: `${d}： ${changes.before[d] ?? ''}`,
            new: `${d}： ${changes.after[d] ?? ''}`,
            id: `diff-${changes.before.key}-${d}`
          }
        }
      }).filter(Boolean)
    },
    formatContent(changes){
      if (!changes.before) {
        const data = this.langs.map(d => {
          if (changes.after[d] && changes.after[d] !== '') {
            return {
              key: `${changes.after.key}`,
              new: `${d}： ${changes.after[d] || ''}`,
              id: `diff-${changes.after.key}-${d}`
            }
          }
          return null
        })
        return data.filter(Boolean)
      }

      if (!changes.after) {
        const data = this.langs.map(d => {
          if (changes.before[d] && changes.before[d] !== '') {
            return {
              key: `${changes.before.key}`,
              old: `${d}： ${changes.before[d]}`,
              id: `diff-${changes.before.key}-${d}`
            }
          }
          return null
        })
        return data.filter(Boolean)
      }
      return this.getDiffContent(changes)
    },
    onChangeItem(ticket, checked){
      if(checked){
        this.selectedTicketList.push(ticket)
      } else {
        this.selectedTicketList = this.selectedTicketList.filter((v)=>v!==ticket)
      }
    },
    showDiff(ticket){
      this.$store.dispatch('getDiff', ticket)
      this.selectedTicket = ticket
      this.$modal.show('ticket')
    },
    onApprove(e) {
      e.preventDefault()
      if (this.selectedTicketList.length) {
        this.$store.commit("setIsConfirmApproveModalOpen", true);
      }
    },
    cancel() {
      if (this.isApproving) return
      this.$store.commit("setIsConfirmApproveModalOpen", false);
    },
    async confirmApprove() {
      if (this.isApproving || !this.selectedTicketList.length) return
      this.isApproving = true
      try {
        await this.$store.dispatch("approveTicket", {
          tickets: [...this.selectedTicketList],
          payload: this.getPayload(),
        })
      } catch (error) {
        this.isApproving = false
      }
    },
    onModalClose(event) {
      if (this.isApproving && this.isConfirmApproveModalOpen) {
        event.cancel()
        return
      }
      if (!this.isApproving) {
        this.$store.commit("setIsConfirmApproveModalOpen", false)
      }
    },
    onApproveModalClosed() {
      if (!this.isApproving) return
      this.selectedTicketList = []
      this.isApproving = false
    },
    searchByTicket() {
      this.$store.dispatch("getUpdatedTickets", this.getPayload());
    },
    onDiffModalClose() {
      this.$store.commit("setCardsHistory", [])
    },
    getPayload(){
      let payload = {}
      if (this.searchTicket) payload['searchTicket'] = this.searchTicket
      payload.pageSize = this.pageSize
      payload.pageNum = this.pageNum
      return payload
    },
    onChange() {
      this.pageSize = this.selectedPageSize.value
      this.pageNum = 1
      this.$store.dispatch("getUpdatedTickets", this.getPayload());
    },
    goToPrevPage() {
      if (this.pageNum > 1) {
        this.pageNum -= 1
        this.$store.dispatch("getUpdatedTickets", this.getPayload())
      }
    },
    goToNextPage() {
      if (this.pageNum < this.totalPages) {
        this.pageNum += 1
        this.$store.dispatch("getUpdatedTickets", this.getPayload())
      }
    },
  },
  watch: {
    project() {
      this.searchTicket = ''
      this.pageNum = 1
      this.$store.dispatch("getUpdatedTickets", this.getPayload());
    },
    isConfirmApproveModalOpen() {
      if(this.isConfirmApproveModalOpen) {
        this.$modal.show("approve");
      } else {
        this.$modal.hide("approve");
      }
    },
    isLoading(){
      this.isLoaded = !this.isLoading
    }
  },
  beforeUpdate() {
    this.totalCount = this.updatedTicketsPage[0]
    this.showingRecords = this.updatedTickets.length
    this.totalPages = this.updatedTicketsPage.totalPages === 0 ? 1 : this.updatedTicketsPage[1]
  },
};
</script>

<style>
.btn-wrapper {
  text-align: right;

  .approve-btn {
    background-color: #21ba45;
    color: #fff;
    box-shadow: 0 0 0 0 rgba(34, 36, 38, 0.15) inset;
    padding: 0.5rem 1.5rem;
    border: none;
    border-radius: 0.3rem;
    cursor: pointer;
    &:hover {
      background-color: #16ab39;
    }
  }
}

.approve-item-container {
  display: flex;
  flex-wrap: wrap;

  .approve-item {
    align-items: center;
    margin-top: 12px;
    flex: 0 0 33.3%;
    font-size: 18px;
  }
}

.approve-modal-container {
  position: relative;
  height: 100%;

  .approve-loading-overlay {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 2;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-size: 16px;

    img {
      width: 50px;
      height: 50px;
      margin-bottom: 8px;
    }
  }

  .modal-title {
    font-weight: bold;
    font-size: 24px;
    padding: 6px 12px;
  }

  .modal-body {
    max-height: 293px;
    text-align: center;
    font-size: 16px;
    overflow: auto;
    padding: 6px 12px;
  }

  .confirm-approve-title {
    font-weight: bold;
    display: flex;
    font-size: 18px;
    justify-content: center;
    align-items: center;
    padding-bottom: 10px;
  }

  .modal-footer {
    display: flex;
    justify-content: flex-end;
    padding: 6px 12px;

    .button {
      margin-left: 16px;
      color: #fff;
      box-shadow: 0 0 0 0 rgba(34, 36, 38, 0.15) inset;
      padding: 0.5rem 1.5rem;
      border: none;
      border-radius: 0.3rem;
      cursor: pointer;

      &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
      }

      &.confirm-btn {
        background-color: #21ba45;
        &:hover {
          background-color: #16ab39;
        }
      }

      &.cancel-btn {
        background-color: #a5673f;
        &:hover {
            background-color: #975b33;
        }
      }
    }
  }
}

.confirm-approve-tickets-container {
  .confirm-approve-ticket-item {
    & + & {
      margin-top: 8px;
    }
  }
}

.key {
  font-size: 24px;
  margin-top: 5px;
}

.old {
  display: flex;
  background: #cb9898;
}

.new {
  display: flex;
  background: #d4ffb2;
}

.footer {
  position: fixed;
  bottom: 0;
  padding: 10px 10px;
  width: 93.55%;
  background: #eeeeee;
}

.pages {
  float: right;
  margin-right: 10px;
  border: 1px solid #eeeeee;
  padding: 3px;
  padding-left: 50px;
  padding-right: 50px;
  background-color: white;
}

.prevPage {
  float: right;
  margin-right: 10px;
  margin-top: 1px;
}

.nextPage {
  float: right;
  margin-right: 10px;
  margin-top: 1px;
}

</style>
